import React, { useMemo } from "react";
import Slider, { SliderSlide } from "components/Slider";

import { BackgroundColor } from "types/componentBackground";
import { useRemotePromos } from "../../ssc-api/useRemotePromos";
import ErrorBoundary from "components/ErrorBoundary";
import OfferSliderCard, {
  isOfferSliderCardValid,
  OfferSliderCardLoading
} from "../Card/OfferSliderCard";
import {
  OffersVisibility,
  filterByVisibility
} from "src/utils/offerVisibilityHelper";
import { CollectionSliderExclusiveOfferPerPromoFragment } from "types/graphql-types";
import { isPresent } from "src/utils/checks";
import { mergeOffersStaticContentWithRemote } from "src/utils/promos";

export interface PromosSliderProps {
  cardBackgroundColor?: BackgroundColor;
  offersVisibility?: undefined | OffersVisibility;
  data: CollectionSliderExclusiveOfferPerPromoFragment[];
}

const PromosSlider: React.FC<React.PropsWithChildren<PromosSliderProps>> = ({
  cardBackgroundColor,
  offersVisibility = "hideOffersCollection",
  data
}) => {
  const { data: dynamicData, status } = useRemotePromos();

  const mergedData = useMemo(() => {
    const filteredOffers =
      (offersVisibility
        ? filterByVisibility(data, offersVisibility)
        : data
      )?.filter(isPresent) || [];

    return mergeOffersStaticContentWithRemote(
      filteredOffers,
      dynamicData
    ).filter(isOfferSliderCardValid);
  }, [dynamicData, offersVisibility]);

  return (
    <ErrorBoundary>
      <Slider
        variantColor={cardBackgroundColor}
        data-content-name="offers_slider"
      >
        {status == "success" && mergedData.length > 0
          ? mergedData.map((item) => {
              return (
                <SliderSlide key={item._id}>
                  <OfferSliderCard
                    offer={item}
                    cardBackgroundColor={cardBackgroundColor}
                  />
                </SliderSlide>
              );
            })
          : [1, 2, 3, 4].map((item) => {
              return (
                <SliderSlide key={`card-loading${item}`}>
                  <OfferSliderCardLoading
                    cardBackgroundColor={cardBackgroundColor}
                  />
                </SliderSlide>
              );
            })}
      </Slider>
    </ErrorBoundary>
  );
};

export default React.memo(PromosSlider);
